import {ref, Ref} from '@vue/composition-api';

type Callback = () => void;
export class EditorDialogApiLoginStoreControllerClass {
	private static _instance: EditorDialogApiLoginStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogApiLoginStoreControllerClass());
	}

	private _displayed!: Ref<boolean>;
	private _error_message!: Ref<string | null>;
	private _callback: Callback | undefined;
	private constructor() {}

	init() {
		this._displayed = ref(false);
		this._error_message = ref(null);
	}

	displayed(): boolean {
		return this._displayed.value;
	}
	error_message(): string | null {
		return this._error_message.value;
	}

	//
	// methods
	//
	async show() {
		return new Promise((resolve) => {
			this._displayed.value = true;
			this._callback = () => {
				resolve(undefined);
			};
		});
	}
	hide() {
		this._displayed.value = false;
	}
	execute_callback() {
		if (!this._callback) {
			return;
		}
		const callback = this._callback;
		this._callback = undefined;
		callback();
	}
	set_error_message(message: string | null) {
		this._error_message.value = message;
	}
}

export const EditorDialogApiLoginStoreController = EditorDialogApiLoginStoreControllerClass.instance();
